export default "__VITE_ASSET__C3JH33R9__"